import Delete from "@mui/icons-material/Delete";
import Settings from "@mui/icons-material/Settings";
import {
  Button,
  Chip,
  Grid,
  IconButton,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import {
  useConnectorConfigUrl,
  useConnectorStatus,
  useConnectorTables,
  useDeletePullConnector,
  useFetchConnectorPageData,
  useFetchConnectorUrl,
  useGetConnector,
  useFetchPullConnectorListener,
  usePullConnectorRouteParamListener,
  usePullConnectorTablePath,
  useFetchPullConnectorUrlListener,
  useSelectedPullConnector,
} from "../../../hook/pullConnector";
import { NoteBlockContainer, NotePageContainer } from "../../note";

export const PullConnectorStatusBlock: React.FC = () => {
  const [selectedPullConnector, setSelectedPullConnector] =
    useSelectedPullConnector();
  const connectorStatus = useConnectorStatus(selectedPullConnector!);
  const configUrl = useConnectorConfigUrl(selectedPullConnector);
  const deleteConnector = useDeletePullConnector();

  return (
    <NoteBlockContainer
      name={"Status"}
      toolbar={
        <>
          {configUrl && (
            <IconButton
              color="primary"
              onClick={() => {
                window.open(configUrl);
              }}
            >
              <Settings />
            </IconButton>
          )}
          <IconButton
            color="primary"
            onClick={() => {
              deleteConnector({ connectorId: selectedPullConnector! });
            }}
          >
            <Delete />
          </IconButton>
        </>
      }
    >
      {connectorStatus && (
        <Grid container spacing={1} sx={{ width: "20rem" }}>
          <Grid item xs={6}>
            <Typography variant="body2">Setup State:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Chip
              label={connectorStatus.setup_state}
              color={
                connectorStatus.setup_state === "incomplete"
                  ? "error"
                  : connectorStatus.setup_state === "connected"
                  ? "success"
                  : "default"
              }
              size="small"
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">Schema Status:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Chip
              label={connectorStatus.schema_status}
              color={
                connectorStatus.schema_status === "ready"
                  ? "success"
                  : "default"
              }
              size="small"
            />
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2">Sync State:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Chip
              label={connectorStatus.sync_state}
              color="default"
              size="small"
            />
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2">Update State:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Chip
              label={connectorStatus.update_state}
              color="default"
              size="small"
            />
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2">Historical Sync:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Chip
              label={connectorStatus.is_historical_sync ? "Yes" : "No"}
              color={"default"}
              size="small"
            />
          </Grid>
        </Grid>
      )}
    </NoteBlockContainer>
  );
};

export const PullConnectorTablesBlock: React.FC = () => {
  const [selectedPullConnector, setSelectedPullConnector] =
    useSelectedPullConnector();
  const tables = useConnectorTables(selectedPullConnector!);
  const pullConnectorTablePath = usePullConnectorTablePath();

  return (
    <NoteBlockContainer name={"Tables"}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Table Id</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tables.map((table) => {
            return (
              <TableRow key={table["file-id"]}>
                <TableCell>{table.name}</TableCell>
                <TableCell>
                  <Link
                    href={pullConnectorTablePath({
                      pullConnectorId: selectedPullConnector!,
                      tableId: table["table-id"],
                    })}
                  >
                    <Button>{table["table-id"]}</Button>
                  </Link>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </NoteBlockContainer>
  );
};

export const PullConnectorPage: React.FC = () => {
  usePullConnectorRouteParamListener();
  useFetchPullConnectorUrlListener();
  useFetchPullConnectorListener();
  const [selectedPullConnector, setSelectedPullConnector] =
    useSelectedPullConnector();
  const getConnector = useGetConnector();
  const connector = getConnector(selectedPullConnector!);
  const schemaName = connector?.card.schema;

  return (
    <NotePageContainer pageName={schemaName ?? ""}>
      <PullConnectorStatusBlock />
      <PullConnectorTablesBlock />
    </NotePageContainer>
  );
};
